// A question only counts toward "publishable" if it has a real label — guards
// against blank cards and the literal string "undefined"/"null" that shows up
// when a question object is hand-edited via the JSON panel without a label.
// Mirrors apps/api/src/services/formValidation.ts — keep both in sync; the
// server re-checks this independently rather than trusting the button state.
export function isValidQuestion(q: any): boolean {
  if (!q || typeof q !== 'object') return false;
  const label = q.label;
  if (typeof label !== 'string') return false;
  const trimmed = label.trim();
  if (!trimmed) return false;
  return trimmed.toLowerCase() !== 'undefined' && trimmed.toLowerCase() !== 'null';
}

export function hasValidQuestion(questions: any[]): boolean {
  return Array.isArray(questions) && questions.some(isValidQuestion);
}
